import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DragSource as dragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import _ from 'lodash';

import ReactDataGrid from 'react-data-grid';
import DnDItemTypes from '../DynamicDnD/DnDItemTypes';

const dragItemsSource = {
  beginDrag(props) {
    const selectedEntries = props.getSelectedEntries();
    props.handleAnswersPreview(selectedEntries);
    return { gridCategory: props.gridCategory, selectedEntries };
  },
};
function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}

class DataGridRowRenderer extends Component {
  componentDidMount() {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true,
    });
  }

  setScrollLeft(scrollBy) {
    // if you want freeze columns to work, you need to make sure you implement this as apass through
    this.row.setScrollLeft(scrollBy);
  }

  render() {
    // here we are just changing the style
    // but we could replace this with anything we liked, cards, images, etc
    // usually though it will just be a matter of wrapping a div,
    // and then calling back through to the grid
    const { connectDragSource, isDragging } = this.props;
    const newProps = _.cloneDeep(this.props);

    if (
      this.props.allSelectedKPIsInfo &&
      this.props.allSelectedKPIsInfo[this.props.row.keyword] &&
      this.props.allSelectedKPIsInfo[this.props.row.keyword].modeled === true
    ) {
      newProps.row.title = `${String.fromCharCode(10020)} ${
        newProps.row.originalTitle
      }`;
    } else if (
      this.props.dataScreen === 'QuickReports' &&
      this.props.allSelectedQuickReportsKPIsInfo &&
      this.props.allSelectedQuickReportsKPIsInfo[this.props.row.keyword] &&
      this.props.allSelectedQuickReportsKPIsInfo[this.props.row.keyword]
        .modeled === true
    ) {
      newProps.row.title = `${String.fromCharCode(10020)} ${
        newProps.row.originalTitle
      }`;
    } else if (newProps.row.originalTitle) {
      // kind of a kludgy solution because I don't get this code
      if (this.props.dataScreen !== 'CAC_CorrCluster' || newProps.row.title.length === 0) {
        newProps.row.title = `${newProps.row.originalTitle}`;
      }
    }
    if (this.props.row.isBlank) {
      return (
        <div onMouseOver={e => this.props.hoverHandle(e, this.props)}>
          <ReactDataGrid.Row
            ref={c => {
              this.row = c;
            }}
            {...newProps}
          />{' '}
        </div>
      );
    }

    if (this.props.isRowsDraggable) {
      return connectDragSource(
        <div
          style={{
            opacity: isDragging ? 0.5 : 1,
          }}
          onMouseOver={e => this.props.hoverHandle(e, this.props)}
          onMouseDown={e => this.props.handleRowMouseDown(e, this.props)}
          onMouseUp={e => this.props.handleRowMouseUp(e, this.props)}
        >
          <ReactDataGrid.Row
            ref={c => {
              this.row = c;
            }}
            {...newProps}
            onKeyUp={e => e.preventDefault()}
          />
        </div>
      );
    }
    return (
      <div
        style={{
          opacity: isDragging ? 0.5 : 1,
        }}
        onMouseOver={e => this.props.hoverHandle(e, this.props)}
        onMouseDown={e => this.props.handleRowMouseDown(e, this.props)}
        onMouseUp={e => this.props.handleRowMouseUp(e, this.props)}
      >
        <ReactDataGrid.Row
          ref={c => {
            this.row = c;
          }}
          {...newProps}
          onDoubleClick={e => this.props.handleRowDoubleClick(e, this.props)}
        />
      </div>
    );
  }
}

DataGridRowRenderer.propTypes = {
  dataScreen: PropTypes.string,
  connectDragSource: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func,
  handleRowMouseDown: PropTypes.func,
  handleRowMouseUp: PropTypes.func,
  handleRowDoubleClick: PropTypes.func,
  row: PropTypes.shape({ isBlank: PropTypes.bool }),
  isDragging: PropTypes.bool.isRequired,
  isRowsDraggable: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    allSelectedKPIsInfo: state.crosstab.allSelectedKPIsInfo,
    allSelectedQuickReportsKPIsInfo:
      state.quickReports.allSelectedQuickReportsKPIsInfo,
  };
}

export default dragSource(
  DnDItemTypes.DnD_ITEM_TYPE_3,
  dragItemsSource,
  collect
)(connect(mapStateToProps)(DataGridRowRenderer));
